<template>
  <input class="form-control" type="text" :class="{ 'is-invalid': invalid, 'is-valid':valid }" :placeholder="placeholder"
         :value="modelValue" ref="input" @input="inputText" >
</template>

<script setup>
import { ref, defineProps } from 'vue';
const props = defineProps({
    modelValue: String,
    placeholder: String,
    invalid: Boolean,
    valid: Boolean,
    konaType: String,
  }) 

const emit = defineEmits(["update:modelValue"])

const input = ref()

const inputText = () => {
  if (props.konaType === 'Number') input.value.value = input.value.value.replace(/[^0-9]/g, '');
  emit('update:modelValue', input.value.value);
}

</script>

<style scoped>
input {
  border-radius:0.375rem;
}
</style>